/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = require('handlebars/runtime');
